import { render, staticRenderFns } from "./FeedCompanies.vue?vue&type=template&id=2a31bab3"
import script from "./FeedCompanies.vue?vue&type=script&lang=js"
export * from "./FeedCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports